import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { CartListModel, CartObj } from 'src/app/models/cart-list.model';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { CartService } from 'src/app/services/cart/cart.service';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { CreditService } from 'src/app/services/credit/credit.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { MobileVerificationFlowService } from 'src/app/services/Auth/mobile-verification-flow.service';

@Component({
  selector: 'ipm-credit-popup',
  templateUrl: './credit-popup.component.html',
  styleUrls: ['./credit-popup.component.scss']
})
export class CreditPopupComponent implements OnInit {
  @Input() currentSoundData: any = "";
  isCouponPopupFlow: boolean = false;
  showCouponPopup: boolean = false;
  availableCouponData: any = null;
  @ViewChild('couponAvailablePopup', { static: false }) couponAvailablePopup: TemplateRef<any>;
  @Output() orderSuccessEvent: EventEmitter<any> = new EventEmitter();
  cartListData: Array<CartObj> = [];
  constructor(private commonService: CommonService,
  private cartService: CartService,
  private router: Router,
  private ga4Tracking: Ga4trackingService,
  private browserService: BrowserStorageService,
  private creditService: CreditService,
  private mobileVerificationFlow: MobileVerificationFlowService) {}

  ngOnInit(): void {
    this.commonService.cartDataList.subscribe( (cartsObj: CartListModel) => {
      if (Object.keys(cartsObj).length) {
        this.cartListData = cartsObj.carts
      }
    });
  }

  get isDiwaliSale(): boolean {
    return this.commonService.isBeatOnSale(this.currentSoundData?.currentBeat);
  }

  purchaseSound() {
    this.cartService.purchaseSoundWithCredit(this.currentSoundData?.currentBeat?._id).subscribe((item: any) => {
        //ga4 tracking for purchase with credit
        let eventname = `checkout_completed_credit_${this.currentSoundData?.currentBeat?.creditPrice}`;
        let attributes = {
          category : 'Sound',
          label:'soundKits',
          action :'click' , 
          value : this.currentSoundData?.currentBeat?.creditPrice || 0,
          userId: this.browserService?.getUserId() || 'guest',
          userRole : this.browserService?.getCurrentRoles() || 'guest',
          soundName : this.currentSoundData?.currentBeat?.title || 'NA',
          soundId : this.currentSoundData?.currentBeat?._id || 'NA',
          currency: 'CREDITS'
        }
        this.ga4Tracking.sendEvent(eventname, attributes);
        this.ga4Tracking.sendEvent('Purchase', attributes);
      const found =  this.cartListData.find( item => item?.beat?._id ===  this.currentSoundData?.currentBeat?._id); 
       if (found) {
            this.cartService.deleteCartData(found._id).subscribe( res => {
              this.updatedCredits();
            }, (error) => {
              this.commonService.closePopUp();
              this.commonService.showToastError(error);
            })
        } else {
          this.updatedCredits();
        }
    }, (error: any) => {
      this.commonService.closePopUp();
      this.commonService.showToastError(error);
    })
  }

  updatedCredits() {
   let creditData =  this.currentSoundData?.availableCredits;
   if (creditData) {
    this.orderSuccessEvent.emit("soundCreditPurchase");
    setTimeout(() => {
      let availableCredits = creditData - this.currentSoundData?.currentBeat?.creditPrice;
      this.commonService.currentCreditBalanceChanges.next(availableCredits); 
    });
   }
  }


  addToCart(isRedirectToCart: boolean = false) {
    let dataLocal = this.browserService.getSessionData();
      if (dataLocal) { 
        const found =  this.cartListData.find( item => item?.beat?._id ===  this.currentSoundData?.currentBeat?._id);
            
        // Extract the price - handle both beats and sound kits
        let beatPrice = null;
        beatPrice = this.currentSoundData?.currentBeat?.price?.final_price ?? null;
        // NEW: Check if sound kit is free (price is 0 or null)
      if ((beatPrice === 0 || beatPrice === null)) {
        this.downloadFreeSound();
        return;
      }
        if (found) {
            this.cartService.deleteCartData(found._id).subscribe( res => {
            this.addSoundIntoCart('showChangeMessage', isRedirectToCart);
            }, (error) => {
              this.commonService.showToastError(error);
            })
        } else {
        this.addSoundIntoCart('', isRedirectToCart);
        }
      } else {
        this.commonService.closingPopupWithSendData('login-alert');
      }
  }

/**
 * Download free sound and redirect to orders
 */
downloadFreeSound() {
  // You'll need to inject SoundKitService in the constructor
  this.cartService.downloadFreeSound(this.currentSoundData?.currentBeat?._id).subscribe(
    (response: any) => {
      this.orderSuccessEvent.emit("soundKitFree");
    },
    (error: any) => {
      if (this.mobileVerificationFlow.triggerFromError(error, 'download')) {
        return;
      }
      this.commonService.closePopUp();
      this.commonService.showToastError(error);
    }
  );
}


  /**
  * Add beat Into Cart Call Api 
  * According to check 
  * @param messageType : string
  */
  addSoundIntoCart(messageType: string = '', isRedirectToCart: boolean = false) {
    // For sound kits, use sample_id instead of beat_id
    const data: any = {
      "sound_id": this.currentSoundData?.currentBeat._id,
      "sound_price": this.currentSoundData?.currentLic?.priceDetails._id
    }

    let InsertAPiCall = this.cartService.insertCartData(data);
      forkJoin([InsertAPiCall]).subscribe( res => {
      this.commonService.closePopUp();
      this.cartService.getCarts().subscribe( (cartsObj: CartListModel) => {
        if (Object.keys(cartsObj).length) {
          this.commonService.cartDataList.next(cartsObj);
        }
      });


      const availableCoupons = res[0]?.data?.carts?.[0]?.beat?.available_coupons;

      if (availableCoupons && availableCoupons.length > 0) {
        // Show coupon available popup
        this.handleCouponAvailableFlow(availableCoupons[0], messageType, isRedirectToCart);
      } else {
        // Normal flow - close popup and show success message
        this.commonService.closePopUp();
        this.reDirectToCart(messageType, 'addBeatIntoCart');
      }
    }, (error) => {
      this.commonService.closePopUp();
      this.commonService.showToastError(error);
    });
  }

  reDirectToCart(messageType: string = '', callingFnction: string = '') {
    let messageShow =  "Sound Kits added to your cart successfully.";
    if(!this.isCouponPopupFlow){
      this.commonService.showToastSuccess(messageShow);
      this.isCouponPopupFlow=false;
    }
    if (callingFnction === 'go_to_cart') {
       this.commonService.showToastSuccess("Coupon applied successfully.");
      setTimeout(() => {
        this.router.navigate(['/cart']);
      }, 100);
    }
   
  }

  handleCouponAvailableFlow(couponData: any, messageType: string, isRedirectToCart: boolean) {
    this.availableCouponData = {
      coupon: couponData,
      isRedirectToCart: isRedirectToCart,
      messageType: messageType
    };
    this.showCouponPopup = true;
    this.commonService.closePopUp();

    //show success toast first 
    let messageShow = messageType ? "Your license has been updated." : "Beat added to your cart successfully.";
    this.commonService.showToastSuccess(messageShow);
    // Open the coupon popup
    let className = this.commonService.isMobileDisableClick ? 'ipm-mobile-view-ipm-applied-coupon' : 'ipm-applied-coupon-model';

    this.commonService.openModel(this.couponAvailablePopup, this.availableCouponData, className);
    this.isCouponPopupFlow=true ; 
    // Handle popup close
    if (this.commonService.isMobileDisableClick) {
      this.commonService.bottomRef.afterDismissed().subscribe(response => {
        this.showCouponPopup = false;
        if (response === 'go_to_cart' || isRedirectToCart) {
            this.reDirectToCart(messageType, 'go_to_cart');
        }
      });
    } else {
      this.commonService.modelRef.afterClosed().subscribe(response => {
        this.showCouponPopup = false;
        if (response === 'go_to_cart' || isRedirectToCart) {
          this.reDirectToCart(messageType, 'go_to_cart');
        }
      });
    }
  }

  closeCouponPopup() {
    this.showCouponPopup = false;
    this.commonService.closePopUp();
  }

  goToCartWithCoupon() {
    this.closeCouponPopup();
    setTimeout(() => {
      this.router.navigate(['/cart']);
    }, 100);
  }

}
